import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { Observable } from 'rxjs';
import { UserProfile } from 'src/app/models/userprofile.model';
import jwt_decode from 'jwt-decode';
import { adminRoles } from './access-roles';

@Injectable({
    providedIn: 'root',
})
export class AuthorizationGuard  {

    constructor(private oauthService: OAuthService, private router: Router) {
    }

    canActivate(
        route: ActivatedRouteSnapshot): | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {

        const allowedRoles: string[] = route.data.accessroles;

        if (!this.accessToken && !this.hasRequiredRoles(allowedRoles)) {
            return false;
        }
        else if (this.accessToken && !this.hasRequiredRoles(allowedRoles)) {
            this.router.navigate(['/access-denied']);
            return false;
        }

        return true;
    }

    get accessToken() {
        return this.oauthService.getAccessToken();
    }

    private getCurrentUserRoles(): string[] {
        const userProfile: UserProfile = jwt_decode(this.accessToken);

        return userProfile.roles;
    }

    private hasRequiredRoles(allowedRoles: string[]): boolean {
        
        if (!allowedRoles) {
            console.error("Invalid (or) No Allowed Roles was configured");
            return false;
        }

        const currentUserRoles: string[] = this.getCurrentUserRoles();
        
        const matchingRoles: string[] = allowedRoles.filter((role: string) =>
            currentUserRoles.includes(role)
        );

        if (matchingRoles.length === 0) {
            console.error("User does not have any required roles.");
            return false;
        }
        return true;
    }

}
